export default "<app-detail [title] = \"title\" [cardType] = \"cardType\" [buttonType] = \"buttonType\" [cards] = \"apiCreators\" ></app-detail>\n"